export const passwordRequirements = [
  "Vähintään 12 merkkiä",
  "Yksi iso kirjain",
  "Yksi pieni kirjain",
  "Yksi numero",
  "Yksi erikoismerkki",
  "Ei välilyöntejä",
];

export function validatePassword(password, { email = "", name = "" } = {}) {
  const value = String(password || "");

  if (value.length < 12) {
    return {
      isValid: false,
      error: `Salasanan on sisällettävä: ${passwordRequirements.join(", ")}.`,
    };
  }

  if (!/[A-Z]/.test(value) || !/[a-z]/.test(value) || !/[0-9]/.test(value) || !/[^A-Za-z0-9]/.test(value) || /\s/.test(value)) {
    return {
      isValid: false,
      error: `Salasanan on sisällettävä: ${passwordRequirements.join(", ")}.`,
    };
  }

  const loweredPassword = value.toLowerCase();
  const personalFragments = [email, name]
    .flatMap((entry) => String(entry || "").toLowerCase().split(/[^a-z0-9]+/i))
    .filter((entry) => entry.length >= 3);

  if (personalFragments.some((fragment) => loweredPassword.includes(fragment))) {
    return {
      isValid: false,
      error: "Salasana ei saa sisältää nimeäsi tai sähköpostiosoitettasi.",
    };
  }

  return { isValid: true };
}